import { FaSave } from 'react-icons/fa';
import { Button } from '../../../../ui/button';
import { toast } from 'react-toastify';

const ContentCards = ({ contentCards }) => {
    if (!contentCards || !Array.isArray(contentCards)) {
        return null;
    }

    return (
        <div className="mt-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
                {contentCards.map((card, cardIndex) => (
                    <div 
                        key={cardIndex} 
                        className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow"
                    >
                        <div className="flex items-center justify-between mb-2">
                            <span className={`text-xs px-2 py-1 rounded-full ${
                                card.type === 'quote' 
                                    ? 'bg-purple-100 text-purple-700' 
                                    : 'bg-blue-100 text-blue-700'
                            }`}>
                                {card.type === 'quote' ? 'Quote' : 'Post'}
                            </span>
                        </div>
                        
                        <h4 className="font-medium text-sm text-gray-900 mb-2" style={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden'
                        }}>
                            {card.title}
                        </h4>
                        
                        <p className="text-xs text-gray-600 mb-3" style={{
                            display: '-webkit-box',
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden'
                        }}>
                            {card.content}
                        </p>
                        
                        <div className="flex flex-wrap gap-1 mb-3">
                            {card.hashtags.slice(0, 3).map((hashtag, hashIndex) => (
                                <span 
                                    key={hashIndex}
                                    className="text-xs text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded"
                                >
                                    {hashtag}
                                </span>
                            ))}
                            {card.hashtags.length > 3 && (
                                <span className="text-xs text-gray-500">
                                    +{card.hashtags.length - 3}
                                </span>
                            )}
                        </div>
                        
                        <Button
                            variant="outline"
                            size="sm"
                            onClick={() => {
                                // Copy content to clipboard
                                navigator.clipboard.writeText(`${card.content}\n\n${card.hashtags.join(' ')}`);
                                toast.success('Content copied to clipboard!');
                            }}
                            className="w-full text-xs"
                        >
                            <FaSave className="h-3 w-3 mr-1" />
                            Copy Content
                        </Button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ContentCards; 